import React from 'react';

import TInputHelper from './TInputHelper';
import { TextRegular } from '../../components/Text';

const InputHelper = ({ children, id }: TInputHelper) => (
  <TextRegular as="span" color="text-secondary" name="helper" id={id}>
    {children}
  </TextRegular>
);

export default InputHelper;
